import { render, staticRenderFns } from "./ErrorCard.vue?vue&type=template&id=73752d0c&scoped=true&"
import script from "./ErrorCard.vue?vue&type=script&lang=ts&"
export * from "./ErrorCard.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorCard.vue?vue&type=style&index=0&id=73752d0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73752d0c",
  null
  
)

export default component.exports